import { useState } from "react";

const PricingCards = () => {

    const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  return (
    <>
      <div className="bg-color-offer offer-bg ">
        <div className=" mx-auto  md:px-6 px-4 py-8 max-w-4xl  pt-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
            {/* Subscribe & Save Package - Desktop */}
            <div className="hidden md:block">
              <div
                className="bg-white overflow-hidden self-start rounded-[12px]"
                style={{
                  border: "3px solid #c79d4c80",
                  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
                  position: "relative",
                }}
              >
                <div className="text-white p-4 flex items-center flex-col bg-[#233751]">
                  <h2 className="text-[24px] font-bold text-center">
                    Subscribe & Save Package
                  </h2>
                </div>

                <div className="p-4 bg-white">
                  <div className="flex justify-center mb-4">
                    <img
                      src="https://media.fileverge.com/yNW-subsbox.svg"
                      alt="Vitality Box"
                      className="h-full w-full"
                    />
                  </div>

                  <p className="text-[#7A7C7B] text-[16px] text-center font-bold leading-[28px]">
                    Regular Price:
                    <span className="relative inline-block">
                      <span className="text-[16px] text-[#7A7C7B]">
                        $620.75
                      </span>
                      <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <span className="block w-[90%] h-[2px] bg-[#690C0C] rotate-[8deg]"></span>
                      </span>
                    </span>
                  </p>

                  <p className="text-[#AB7C3B] font-bold text-[24px] text-center leading-[28px]">
                    YOUR VIP RATE
                  </p>

                  <div className="relative leading-[28px]">
                    <div className="text-[#233751] rounded-[6px] flex items-center justify-center mt-2">
                      <span className="text-[16px] font-bold bottom-[3.5px] absolute left-[45%] transform -translate-x-1/2">
                        $
                      </span>
                      <span className="text-[32px] font-bold">0</span>
                    </div>
                  </div>

                  <p className="text-[#233751] text-[16px] font-bold mt-2 text-center pt-3">
                    CLAIM YOUR VOUCHER & SAVE NOW!
                  </p>

                  <div className="flex items-center justify-center gap-1 mt-2">
                    <img src="images/Shipped.svg" alt="" />
                    <p className="text-[#000000] text-[14px] text-center">
                      + $29.95 SHIPPING
                    </p>
                  </div>

                  <p className="text-[#000000] text-[16px] text-center font-black uppercase">
                    then $67/mo after 30 days
                  </p>

                  <div className="consent-section">
                    <label className="flex items-start mt-4 gap-2">
                      <input
                        type="checkbox"
                        className="consent-checkbox mt-1"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <div>
                        <h2 className="text-base font-bold text-black">
                          Yes! Give Me My First Vitality Box Today
                        </h2>
                        <p className="text-xs text-gray-700">
                          By checking this box, you will receive a Vitality Box
                          (all 4 items) and pay just{" "}
                          <strong>$0 + $29.95 shipping</strong>. If after 30
                          days you choose to continue with your Vitality Box
                          subscription, you will NEVER pay the regular price of
                          $719.00. Instead, you’ll receive a discounted rate of
                          just <strong>$67 + $29.95 shipping</strong> every 30
                          days for all 4 items in your Vitality Box for as long
                          as you wish. If you wish to cancel your subscription
                          at any time, it’s easy—just email or call us, and it
                          will be cancelled immediately.
                        </p>
                      </div>
                    </label>

                    <div className="flex items-center justify-center pt-3 transition ease-in-out duration-300 hover:translate-y-[2px]">
                      <a
                        href="https://scalequick.pay.clickbank.net/?cbitems=13&cbur=a&cbrblaccpt=true"
                        className={`order-button ${
                          !isChecked ? "pointer-events-none opacity-50" : ""
                        }`}
                      >
                        <img
                          src="https://media.fileverge.com/P0M-goldenbtn.svg"
                          alt="Order Now"
                          draggable="false"
                        />
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center justify-center pt-2">
                    {/* <a href="#"> */}
                    <img
                      src="https://media.fileverge.com/5RO-payemnt.svg"
                      alt=""
                      draggable="false"
                    />
                    {/* </a> */}
                  </div>
                </div>

                <div className="text-white p-2 flex items-center flex-col bg-[#233751]">
                  <h2 className="text-[14px] font-bold italic">
                    (Can be canceled at any time)
                  </h2>
                </div>
              </div>
            </div>

            {/* Subscribe & Save Package - Mobile */}
            <div className="block md:hidden">
              <div
                className="bg-white overflow-hidden self-start"
                style={{
                  position: "relative",

                  padding: "3px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(71.4deg, #856220 -127.9%, #f4e683 -56.56%, #bf923d 1.81%, #4e341b 66.66%, #f1ea82 131.52%)",
                  boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              >
                <div
                  className="text-white p-4 flex items-center flex-col"
                  style={{
                    background:
                      "linear-gradient(175.99deg, #856220 -273.53%, #f4e683 -102.55%, #bf923d 37.35%, #4e341b 192.79%, #f1ea82 348.24%)",
                    borderRadius: "9px 9px 0 0",
                  }}
                >
                  <h2 className="text-[24px] font-bold text-center">
                    Subscribe & Save Package
                  </h2>
                </div>

                <div className="p-4 bg-white">
                  <div className="flex justify-center mb-4 mt-8">
                    <img
                      src="https://media.fileverge.com/yNW-subsbox.svg"
                      alt="Vitality Box"
                      className="h-full w-full"
                    />
                  </div>

                  <p className="text-[#7A7C7B] text-[16px] text-center font-bold leading-[28px]">
                    Regular Price:
                    <span className="relative inline-block">
                      <span className="text-[16px] text-[#7A7C7B]">
                        $620.75
                      </span>
                      <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <span className="block w-[90%] h-[2px] bg-[#690C0C] rotate-[8deg]"></span>
                      </span>
                    </span>
                  </p>

                  <p className="text-[#AB7C3B] font-bold text-[24px] text-center leading-[28px]">
                    YOUR VIP RATE
                  </p>

                  <div className="relative leading-[28px]">
                    <div className="text-[#233751] rounded-[6px] flex items-center justify-center">
                      <span className="text-[16px] font-bold bottom-[3.5px] absolute left-1/2 transform -translate-x-1/2">
                        $
                      </span>
                      <span className="text-[32px] font-bold">0</span>
                    </div>
                  </div>

                  <p className="text-[#233751] text-[16px] font-bold mt-2 text-center pt-3">
                    CLAIM YOUR VOUCHER & SAVE NOW!
                  </p>

                  <div className="flex items-center justify-center gap-1 mt-2">
                    <img src="images/Shipped.svg" alt="" />
                    <p className="text-[#000000] text-[14px] text-center">
                      + $29.95 SHIPPING
                    </p>
                  </div>

                  <p className="text-[#000000] text-[16px] text-center font-black uppercase">
                    then $67/mo after 30 days
                  </p>

                   <div className="consent-section">
                    <label className="flex items-start mt-4 gap-2">
                      <input
                        type="checkbox"
                        className="consent-checkbox mt-1"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <div>
                        <h2 className="text-base font-bold text-black">
                          Yes! Give Me My First Vitality Box Today
                        </h2>
                        <p className="text-xs text-gray-700">
                          By checking this box, you will receive a Vitality Box
                          (all 4 items) and pay just{" "}
                          <strong>$0 + $29.95 shipping</strong>. If after 30
                          days you choose to continue with your Vitality Box
                          subscription, you will NEVER pay the regular price of
                          $719.00. Instead, you’ll receive a discounted rate of
                          just <strong>$67 + $29.95 shipping</strong> every 30
                          days for all 4 items in your Vitality Box for as long
                          as you wish. If you wish to cancel your subscription
                          at any time, it’s easy—just email or call us, and it
                          will be cancelled immediately.
                        </p>
                      </div>
                    </label>

                    <div className="flex items-center justify-center pt-3 transition ease-in-out duration-300 hover:translate-y-[2px]">
                      <a
                        href="https://scalequick.pay.clickbank.net/?cbitems=13&cbur=a&cbrblaccpt=true"
                        className={`order-button ${
                          !isChecked ? "pointer-events-none opacity-50" : ""
                        }`}
                      >
                        <img
                          src="https://media.fileverge.com/P0M-goldenbtn.svg"
                          alt="Order Now"
                          draggable="false"
                        />
                      </a>
                    </div>
                  </div>

                 

                  <div className="flex items-center justify-center pt-2">
                    {/* <a href="#"> */}
                    <img
                      src="https://media.fileverge.com/5RO-payemnt.svg"
                      alt=""
                      draggable="false"
                    />
                    {/* </a> */}
                  </div>
                </div>

                <div
                  className="text-white p-2 flex items-center flex-col"
                  style={{
                    background:
                      "linear-gradient(175.99deg, #856220 -273.53%, #f4e683 -102.55%, #bf923d 37.35%, #4e341b 192.79%, #f1ea82 348.24%)",
                    borderRadius: "0 0 9px 9px",
                  }}
                >
                  <h2 className="text-[14px] font-bold uppercase">
                    (Can be canceled at any time)
                  </h2>
                </div>
              </div>
            </div>

            {/* Regular Package */}
            <div
              className="bg-white shadow-lg rounded-[12px] overflow-hidden border border-gray-200 self-center"
              style={{
                border: "3px solid #233751",
                boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
                position: "relative",
              }}
            >
              <div className="bg-[#233751] text-white p-4 flex items-center flex-col">
                <h2 className="text-[24px] font-bold">Regular Package</h2>
              </div>

              <div className="p-4">
                <div className="flex justify-center mb-4 md:mt-0 mt-8">
                  <img
                    src="https://media.fileverge.com/t7y-onetimebox.svg"
                    alt="Vitality Box"
                    className="h-full w-full"
                  />
                </div>

                <p className="text-[#7A7C7B] text-[16px] text-center font-bold leading-[28px]">
                  Regular Price:
                  <span className="relative inline-block">
                    <span className="text-[16px] text-[#7A7C7B]">$620.75</span>
                    <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <span className="block w-[90%] h-[2px] bg-[#690C0C] rotate-[8deg]"></span>
                    </span>
                  </span>
                </p>

                <p className="text-[#AB7C3B] font-bold text-[24px] text-center leading-[28px]">
                  YOUR VIP RATE
                </p>

                <div className="relative leading-[28px]">
                  <div className="text-[#233751] rounded-[6px] flex items-center justify-center">
                    <span className="text-[16px] font-bold bottom-[3.5px] absolute left-[43%] transform -translate-x-1/2">
                      $
                    </span>
                    <span className="text-[32px] font-bold">77</span>
                  </div>
                </div>

                <div className="flex items-center justify-center gap-1 mt-2">
                  <img
                    src="https://media.fileverge.com/Gno-shipped.svg"
                    alt=""
                  />
                  <p className="text-[#000000] text-[14px] text-center">
                    + $29.95 SHIPPING
                  </p>
                </div>

                <p className="text-[#000000] text-[16px] text-center font-black uppercase">
                  one time fee, no subscription
                </p>

                <div className="flex items-center justify-center py-3 transition ease-in-out duration-300 hover:translate-y-[2px]">
                  <a href="https://scalequick.pay.clickbank.net/?cbitems=12&cbur=a">
                    <img
                      src="https://media.fileverge.com/3qM-onetimebtn.svg"
                      alt=""
                      draggable="false"
                    />
                  </a>
                </div>

                <div className="flex items-center justify-center pt-2">
                  {/* <a href="#"> */}
                  <img
                    src="https://media.fileverge.com/5RO-payemnt.svg"
                    alt=""
                    draggable="false"
                  />
                  {/* </a> */}
                </div>
              </div>

              <div className="bg-[#233751] text-white p-2 flex items-center flex-col">
                <h2 className="text-[14px] font-bold italic">
                  (One Time Payment)
                </h2>
              </div>
            </div>
          </div>
        </div>
        {/* <Contact isVsl={isVsl} /> */}

        <div className="flex flex-col gap-5 py-14 max-w-6xl p-2 mx-auto relative z-10">
          <div className="flex  flex-row items-center md:px-6 px-3">
            <img
              src="https://sinoclear.net/pm/images-nw/contact-us.svg"
              className="w-24 h-auto"
            />
            <p className="text-white md:text-[24px] text-[18px]  font-light md:leading-[30px] leading-[20px]">
              If you are not happy with your purchase for any reason, contact us
              anytime, and we’ll refund every penny of your investment. You
              don’t even have to send the bottles back.
            </p>
          </div>
          <a
            href="#"
            className="text-white cursor-pointer md:text-[24px] text-[24px] text-center md:text-start underline font-light md:px-0 px-3"
          >
            <span>
              <strong className="font-bold">No Thanks</strong>, I understand
              that I will never see this offer again. I’d rather pay full price
              later. Take me to the next page.
            </span>
          </a>
        </div>
      </div>
    </>
  );
};

export default PricingCards;
